module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-contact-section"
  }, [_c('div', {
    staticClass: "custom-contact-section__container"
  }, [_c('div', {
    staticClass: "custom-contact-section__content"
  }, [_c('h2', {
    staticClass: "custom-contact-section__info"
  }, [_vm._v("PHONE: "), _c('a', {
    attrs: {
      "href": _vm.app.information.tel.href
    },
    domProps: {
      "innerHTML": _vm._s(_vm.app.information.tel.label)
    }
  })]), _c('h2', {
    staticClass: "custom-contact-section__info"
  }, [_vm._v("FAX: "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.app.information.fax)
    }
  })]), _c('h2', {
    staticClass: "custom-contact-section__info"
  }, [_vm._v("EMAIL: "), _c('a', {
    attrs: {
      "href": _vm.app.information.e_mail.href
    },
    domProps: {
      "innerHTML": _vm._s(_vm.app.information.e_mail.label)
    }
  })]), _c('h2', {
    staticClass: "custom-contact-section__info"
  }, [_vm._v("LOCATION:"), _c('a', {
    attrs: {
      "href": _vm.app.business_information[0].map_location
    },
    domProps: {
      "innerHTML": _vm._s(_vm.app.business_information[0].address)
    }
  })])]), _c('div', {
    staticClass: "custom-contact-section__map"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": _vm.app.business_information[0].embed_map,
      "width": "100%",
      "height": "100%",
      "frameborder": "0"
    }
  })])]), _c('div', {
    staticClass: "custom-contact-section__form"
  }, [_c('h2', {
    staticClass: "custom-contact-section__form-title"
  }, [_vm._v("Contact Us")]), _c('ContactForm')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2b31a28","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-contact-section/custom-contact-section.pug
// module id = 1144
// module chunks = 1